import e from "../../utils/classNames.js";
import { noop as t } from "es-toolkit/function";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/sidebars/SidebarBackdrop.tsx
var r = ({ onClick: r = t, makeBackdropVisible: i = !1, className: a = "" }) => {
	let o = e("SidebarBackdrop", i && "sidebar-backdrop-bg", a);
	return /* @__PURE__ */ n("div", {
		className: o,
		onClick: r,
		"data-testid": "sidebarBackdrop"
	});
};
//#endregion
export { r as default };

//# sourceMappingURL=SidebarBackdrop.js.map